import classes from "./classes";

let goingDialogUtils = {
    //获取js路径前缀
    getPath() {
        //获取脚本集合
        let js = document.scripts,
            script = js[js.length - 1],
            jsPath = script.src;
        //获取当前的js的路径
        if (!script.getAttribute("merge")) {
            return jsPath.substring(0, jsPath.lastIndexOf("/") + 1);
        }
    },
    //获取当前对象的style
    getStyle: function (elObj, styleProp) {
        var styles = elObj.currentStyle
            ? elObj.currentStyle
            : window.getComputedStyle(elObj, null);
        return styles[
            styles.getPropertyValue ? "getPropertyValue" : "getAttribute"
            ](styleProp);
    },
    link: function (href, fn, cssname) {
        //如果传入了path 则动态的加载link 添加css
        if (goingDialogUtils.getPath()) {
            //获取到head对象
            var a = document.getElementsByTagName("head")[0],
                linkEl = document.createElement("link");
            //如果传入的fn 是字符串 则csname=fn
            "string" == typeof fn && (cssname = fn);

            var l = (cssname || href).replace(/\.|\//g, ""),
                f = "layuicss-" + l;

            (linkEl.rel = "stylesheet"),
                (linkEl.href = goingDialogUtils.getPath() + href),
                (linkEl.id = f),
            document.getElementById(f) || a.appendChild(linkEl);
        }
    },
    ie: (function () {
        //判断是否是ie浏览器
        var t = navigator.userAgent.toLowerCase();
        return (
            !!(window.ActiveXObject || "ActiveXObject" in window) &&
            ((t.match(/msie\s(\d+)/) || [])[1] || "11")
        );
    })(),
    reselect: function () {
        window.__dialog$.each(window.__dialog$("select"), function () {

            var n = window.__dialog$(this);
            n.parents("." + classes[0])[0] ||
            (1 == n.attr("layer") &&
                window.__dialog$("." + classes[0]).length < 1 &&
                n.removeAttr("layer").show()),
                (n = null);
        });
    },
    record: function (e) {
        var t = [
            e.width(),
            e.height(),
            e.position().top,
            e.position().left + parseFloat(e.css("margin-left"))
        ];
        e.find(".layui-layer-max").addClass("layui-layer-maxmin"),
            e.attr({area: t});
    },
    rescollbar: function (e) {
        classes.html.attr("layer-full") == e &&
        (classes.html[0].style.removeProperty
            ? classes.html[0].style.removeProperty("overflow")
            : classes.html[0].style.removeAttribute("overflow"),
            classes.html.removeAttr("layer-full"));
    },
    extend() {
        // copy reference to target object
        var target = arguments[0] || {},
            i = 1,
            length = arguments.length,
            deep = false,
            options;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            target = arguments[1] || {};
            // skip the boolean and the target
            i = 2;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !jQuery.isFunction(target)) target = {};
        // extend jQuery itself if only one argument is passed
        if (length == i) {
            target = this;
            --i;
        }
        for (; i < length; i++)
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null)
            // Extend the base object
                for (var name in options) {
                    var src = target[name],
                        copy = options[name];
                    // Prevent never-ending loop
                    if (target === copy) continue;
                    // Recurse if we're merging object values
                    if (deep && copy && typeof copy === "object" && !copy.nodeType)
                        target[name] = jQuery.extend(
                            deep,
                            src || (copy.length != null ? [] : {}),
                            copy
                        );
                    // Don't bring in undefined values
                    else if (copy !== undefined) target[name] = copy;
                }
        // Return the modified object
        return target;
    },
    config: {},
    end: {},
    minIndex: 0,
    minLeft: [],
    btn: ["&#x786E;&#x5B9A;", "&#x53D6;&#x6D88;"],
    type: ["dialog", "page", "iframe", "loading", "tips"]
};

export default goingDialogUtils;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/goingDialog/goingDialogUtils.js